import { useState } from 'react';
import { addAdminCredentials } from '../utils/addAdminCredentials';

const AddAdminCredentials = () => {
    const [formData, setFormData] = useState({
        username: 'Admin',
        password: 'Admin@123',
        name: 'Super Admin',
        email: ''
    });
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage('Adding admin credentials...');

        try {
            const result = await addAdminCredentials(
                formData.username,
                formData.password,
                formData.name,
                formData.email
            );

            if (result.success) {
                setMessage('✅ Admin credentials added successfully! You can now login.');
            } else {
                setMessage('❌ Error: ' + result.error);
            }
        } catch (error) {
            setMessage('❌ Error: ' + error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{
            padding: '40px',
            maxWidth: '500px',
            margin: '0 auto',
            textAlign: 'center',
            fontFamily: 'Arial, sans-serif'
        }}>
            <h2>Add Admin Credentials</h2>
            <p style={{ marginBottom: '30px', color: '#666' }}>
                Add your admin credentials to the Firebase admin collection.
            </p>

            <form onSubmit={handleSubmit} style={{ textAlign: 'left' }}>
                <div style={{ marginBottom: '20px' }}>
                    <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
                        Username
                    </label>
                    <input
                        type="text"
                        name="username"
                        value={formData.username}
                        onChange={handleInputChange}
                        style={{
                            width: '100%',
                            padding: '10px',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            fontSize: '14px'
                        }}
                        required
                    />
                </div>

                <div style={{ marginBottom: '20px' }}>
                    <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
                        Password
                    </label>
                    <input
                        type="password"
                        name="password"
                        value={formData.password}
                        onChange={handleInputChange}
                        style={{
                            width: '100%',
                            padding: '10px',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            fontSize: '14px'
                        }}
                        required
                    />
                </div>

                <div style={{ marginBottom: '20px' }}>
                    <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
                        Name (Optional)
                    </label>
                    <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        style={{
                            width: '100%',
                            padding: '10px',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            fontSize: '14px'
                        }}
                    />
                </div>

                <div style={{ marginBottom: '20px' }}>
                    <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
                        Email (Optional)
                    </label>
                    <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        style={{
                            width: '100%',
                            padding: '10px',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            fontSize: '14px'
                        }}
                    />
                </div>

                <button
                    type="submit"
                    disabled={loading}
                    style={{
                        width: '100%',
                        padding: '12px',
                        backgroundColor: loading ? '#ccc' : '#007bff',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: loading ? 'not-allowed' : 'pointer',
                        fontSize: '16px',
                        marginBottom: '20px'
                    }}
                >
                    {loading ? 'Adding...' : 'Add Admin Credentials'}
                </button>
            </form>

            {message && (
                <div style={{
                    padding: '15px',
                    backgroundColor: message.includes('✅') ? '#d4edda' : '#f8d7da',
                    border: `1px solid ${message.includes('✅') ? '#c3e6cb' : '#f5c6cb'}`,
                    borderRadius: '4px',
                    color: message.includes('✅') ? '#155724' : '#721c24',
                    marginTop: '20px'
                }}>
                    {message}
                </div>
            )}

            <div style={{ marginTop: '30px', textAlign: 'left' }}>
                <h3>After adding credentials:</h3>
                <ol style={{ paddingLeft: '20px' }}>
                    <li>Go back to the login page</li>
                    <li>Use the same username and password</li>
                    <li>You should be able to login successfully</li>
                </ol>
            </div>
        </div>
    );
};

export default AddAdminCredentials;
